export class Camion {
    idCamion: number;
    matriculation: string;
    transporteur: string;
    chauffeur:string;
    numeroPermis: number;
    datePermis:Date;

}
